module.exports = __webpack_public_path__ + "img/cedric.09f80827.jpg";